import cl from 'clsx'
import styles from './styles.module.css'

/**
 *
 * @param {string} title
 * @param {string} firstLine
 * @param {string} secondLine
 * @param {string} width - "000px"
 * @param {string} color - white
 * @param {string} position - "how"
 * @param {string} br  Add br
 * 
 *
 */

export default function Title({
    title,
    firstLine,
    secondLine,
    width = '1163px',
    color,
    position,
    br,
}) {
    return (
        <div className={styles.title}>
            <div 
                style={{ maxWidth: width }}
                className={cl(
                    position === 'how' && styles.title__how,
                    position === 'testimonials' && styles.title__testimonials
                )}>
                <h1 className={cl(
                        styles.title__first,
                        color === 'white' && styles.title__first_color,
                        position === 'how' && styles.title__color_50
                    )}
                >
                    {title}
                </h1>
                <h2 className={cl(
                        styles.title__second,
                        color === 'white' ? styles.title__white : ''
                    )}>
                    <span className={styles.title__firstline}>{firstLine}</span>{' '}
                    {br && <br />}
                    {secondLine}
                </h2>
            </div>
        </div>
    )
}
